import { Typography } from "@circle-react/components/shared/uikit/Typography";
import type { Event } from "@circle-react/types/Event";
import { RecurringRsvpModal } from "../RecurringRsvpModal";
import { useRecurringRsvpModal } from "../RecurringRsvpModal/hooks/useRecurringRsvpModal";

interface ListRecurringEventButtonProps {
  buttonText: string;
  event: Event;
  onChange: (event: Event) => void;
}

export const ListRecurringEventButton = ({
  event,
  onChange,
  buttonText,
}: ListRecurringEventButtonProps) => {
  const { isRecurringRsvpOpen, openRecurringRsvpModal, onRecurringModalClose } =
    useRecurringRsvpModal({ event });

  return (
    <>
      <button type="submit" onClick={openRecurringRsvpModal}>
        <Typography.LabelSm weight="medium" color="text-link">
          {buttonText}
        </Typography.LabelSm>
      </button>
      <RecurringRsvpModal
        event={event}
        show={isRecurringRsvpOpen}
        onClose={onRecurringModalClose}
        onChange={onChange}
        eventRsvpedByDefault={false}
      />
    </>
  );
};
